import { render, staticRenderFns } from "./PlanejamentoContratoFormFluxoAprovacao.vue?vue&type=template&id=445b7822&scoped=true"
import script from "./PlanejamentoContratoFormFluxoAprovacao.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContratoFormFluxoAprovacao.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoContratoFormFluxoAprovacao.vue?vue&type=style&index=0&id=445b7822&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b7822",
  null
  
)

export default component.exports